package org.matthewo.styles

import emotion.css.cx
import react.PropsWithClassName
import web.cssom.ClassName

inline fun PropsWithClassName.css(
    vararg classNames: ClassName?,
) {
    className = cx(*classNames)
}
